const pdpImageGallery = {
    $imageGallery: undefined,
    init() {
        if ($('#js-pdp__image-gallery-wrapper').data('slick-load')) {
            pdpImageGallery.$imageGallery = $('#pdp__image-gallery');
            pdpImageGallery.bindEventActions();
            pdpImageGallery.initImageGallery();
        }
    },

    bindEventActions() {
        pdpImageGallery.$imageGallery.on('init', function (event, slick) {
            pdpImageGallery.setSlideNumbering(event, slick)
        });

        pdpImageGallery.$imageGallery.on('afterChange', function (event, slick) {
            pdpImageGallery.setSlideNumbering(event, slick)
        });
    },

    setSlideNumbering(event, slick) {
        pdpImageGallery.$imageGallery.find('.slick-slide.slick-active').attr('data-slide-nav',
                `${slick.currentSlide + 1}/${slick.slideCount}`
        );
    },

    initImageGallery() {

        pdpImageGallery.$imageGallery.slick({
            centerMode:    true,
            centerPadding: '200px',
            slidesToShow:  1,
            prevArrow:     $('.pdp__image-gallery-prev'),
            nextArrow:     $('.pdp__image-gallery-next'),
            responsive:    [
                {
                    breakpoint: 1200,
                    settings:   {
                        arrows:        false,
                        centerPadding: '28px'
                    }
                }, {
                    breakpoint: 684,
                    settings:   {
                        arrows:        false,
                        centerPadding: '7px'
                    }
                }
            ]
        });
    },

    exchangeImageGallery(data) {
        let newImageGallery = $(data).find('#js-pdp__image-gallery-wrapper');

        $('#js-pdp__image-gallery-wrapper').replaceWith(newImageGallery);
        pdpImageGallery.init();
    }
};

$(() => {
    pdpImageGallery.init();
});

export default pdpImageGallery;
